import { Component, OnInit, ViewChild, ViewContainerRef, HostListener } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';
import { INavListItem } from 'src/app/models/nav-list-items';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { Store, select } from '@ngrx/store';
import {
  SetUserHistorySelection,
  GetUserActiveCheckinDetailsApiAction,
  SetPreviousUrl
} from 'src/app/app-store/user/user.action';
import { userPermissions, userDetailsActiveCheckinSelector, userDetailsPayload } from 'src/app/app-store/user/user.selector';
import { MsalService } from '@azure/msal-angular';
import { BannerpreviewdialogComponent } from 'src/app/shared/dialogues/bannerpreviewdialog/bannerpreviewdialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AppPermissions } from 'src/app/feature/admin/helper/constants';
import { take } from 'rxjs/operators';
import { LoginTypeSelector } from 'src/app/app-store/login/login.selector';
import { LoginType } from 'src/app/helper/constants';
import { deleteCookie } from 'src/app/feature/login/utils/cookie-utils';
import { SetLoginStatusAction } from 'src/app/app-store/login/login.action';
// import { MsalService } from 'src/app/msal/services/msal.service';
import { environment } from 'src/environments/environment';
import { FileService } from '../services/file.service';

@Component({
  selector: 'app-side-nav-bar',
  templateUrl: './side-nav-bar.component.html',
  styleUrls: ['./side-nav-bar.component.css']
})

export class SideNavBarComponent implements OnInit {

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    if (window.innerHeight >= 320 && window.innerHeight <= 700) {
      this.cssclass = 'div-scroll-sidenav xss';
    } else {
      this.cssclass = 'div-scroll-sidenav xs';
    }
  }

  cssclass: string;
  isOffline = false;
  rippleColor = '#f7f8fb59'; // opacity: 35%
  @ViewChild(MatSidenav) sidenav: MatSidenav;
  userSubscription: Subscription;
  userDetailsActiveCheckinSelectorSubscription: Subscription;
  displayName: string;
  userEmail: string;
  //footerImage = 'assets/images/footer.png';
  footerImage = 'assets/images/lifesavingrules.png';
  onDashboard: boolean;
  showInternal: boolean;
  loginType: string;
  routeLoading: boolean;

  navItems: INavListItem[] = [
    {
      icon: 'assets/icons/home.svg',
      title: 'home',
    },
    // {
    //   icon: 'assets/icons/history.svg',
    //   title: 'history',
    // },
    // {
    //   icon: 'assets/icons/sitematrix.svg',
    //   title: 'site_readiness_matrix'
    // }
  ];

  fixednavItems: INavListItem[] = [
    {
      icon: 'assets/icons/appSetting.svg',
      title: 'app_settings'
    }
  ];

  travelItems: INavListItem[] = [
  ];

  constructor(
    private authService: MsalService,
    private router: Router, private store: Store,
    private bannerDialog: MatDialog,
    private viewRef: ViewContainerRef,
    private fileService : FileService) {
  }

  ngOnInit() {
    this.routeChanges();
    this.getScreenSize();
    this.store.pipe(select(userDetailsPayload)).subscribe(response => {
      if (response !== undefined) {
        this.displayName = response.name;
        this.userEmail = response.email;
      }
    });
    this.store.pipe(select(LoginTypeSelector)).subscribe(response => {
      this.loginType = response;
      if (response === LoginType.Internal_User) {
        this.addDrawerItems('assets/icons/invite_icon.svg', 'send_invite', 4);
        this.addDrawerItems('assets/icons/icn_Certificate.svg', 'My PcP', 5);
        //this.addTravelNavItems('assets/icons/Travel_request.svg', 'Pre-Trip Request', 0);
       // this.addTravelNavItems('assets/icons/countryinfo_icn.svg', 'Country Information', 2);

      }
      this.addFixedItems('assets/icons/faq.svg', 'faq', 0);
      this.addFixedItems('assets/icons/faq.svg', 'faq-pretrip', 1);
      this.addFixedItems('assets/icons/play1.svg', 'user_guide', 2);

      // Master permission data
      this.store.pipe(select(userPermissions)).subscribe(response2 => {
        if (response2) {
          if (response2.some(item => (item.id === AppPermissions.ConfigureComplianceReadiness.id
            || item.id === AppPermissions.Admin.id
            || item.id === AppPermissions.SuperAdmin.id))) {
            this.addDrawerItems('assets/icons/admin.svg', 'admin', 1);
          }
          if (response2.some(permission => (permission.id === AppPermissions.Admin.id ||
            permission.id === AppPermissions.SuperAdmin.id ||
            permission.id === AppPermissions.BuildReports.id))) {
            if (response === LoginType.Internal_User) {
              this.addDrawerItems('assets/icons/sitematrix.svg', 'Contact Tracing', 7);
            }
          }
          if (response2.some(permission => (permission.id === AppPermissions.FirstApprover.id
            || permission.id === AppPermissions.SecondApprover.id || response === LoginType.Internal_User))) {
          //  this.addTravelNavItems('assets/icons/approval.svg', 'approvals', 1); -?removing approval from side menu
          }
          if (response2.some(permission => (permission.id === AppPermissions.Security.id))) {
            this.addDrawerItems('assets/icons/scan-qr.png', 'scan_qr', 6);
          }
        }
      });
    });

  }

  addTravelNavItems = (setIcon, setTitle, index) => {
    if (setIcon && setTitle) {
      const settingObj = {
        icon: setIcon,
        title: setTitle
      };
      if (!this.travelItems.some((item) => item.title === setTitle)) {
        this.travelItems.splice(index, 0, settingObj);
      }
    }
  }

  addFixedItems = (setIcon, setTitle, index) => {
    if (setIcon && setTitle) {
      const settingObj = {
        icon: setIcon,
        title: setTitle
      };
      if (!this.fixednavItems.some((item) => item.title === setTitle)) {
        this.fixednavItems.splice(index, 0, settingObj);
      }
    }
  }

  addDrawerItems = (setIcon, setTitle, index) => {

    if (setIcon && setTitle) {
      const settingObj = {
        icon: setIcon,
        title: setTitle
      };
      if (!this.navItems.some((item) => item.title === setTitle)) {
        this.navItems.splice(index, 0, settingObj);
      }
    }
  }

  listItemClick = (itemName: string): void => {

    this.sidenav.toggle();
    const currentUrl = this.router.url;
    switch (itemName) {
      case 'Logout':
        if (this.loginType === LoginType.External_User) {
          deleteCookie('token');
          this.store.dispatch(SetLoginStatusAction({ loginStatus: false }));
          this.router.navigateByUrl('/login');
        } else if (this.loginType === LoginType.Internal_User) {
          localStorage.clear();
          this.authService.logout({
            postLogoutRedirectUri: environment.authConfig.redirectUri
          });
        }
        break;
      case 'home':
        this.store.dispatch(GetUserActiveCheckinDetailsApiAction());
        this.userDetailsActiveCheckinSelectorSubscription = this.store.pipe(select(userDetailsActiveCheckinSelector)).pipe(take(1)).subscribe(response => {
          if (response !== undefined && response.workingStatusId !== undefined) {
            this.router.navigateByUrl('/dashboard/checkin');
          } else {
            this.router.navigateByUrl('/dashboard/self');
          }
        });
        break;
      case 'history':
        if (currentUrl !== '/history') {
          this.store.dispatch(SetUserHistorySelection({ value: true }));
          this.router.navigateByUrl('/history');
        }
        break;
      case 'admin':
        if (!currentUrl.includes('/admin')) {
          this.store.dispatch(SetUserHistorySelection({ value: true }));
          this.router.navigateByUrl('/admin', { replaceUrl: true });
        }
        break;
      case 'site_readiness_matrix':
        if (!currentUrl.includes('/siteredinessmatrix')) {
          this.store.dispatch(SetUserHistorySelection({ value: true }));
          this.router.navigateByUrl('/siteredinessmatrix/create');
        }
        break;
      case 'faq':
        var fileNames = [];
        fileNames.push("FAQ_One Site Pass.pdf");

        this.fileService.getBlobSASToken('app-tour', fileNames)
          .pipe(take(1))
          .subscribe(responseList => {
            window.open(responseList[0].url, '_blank')
          });
      case 'faq-pretrip':
        var fileNames = [];
        fileNames.push("PTA FAQ.pdf");

        this.fileService.getBlobSASToken('travel-protocol', fileNames)
          .pipe(take(1))
          .subscribe(responseList => {
            window.open(responseList[0].url, '_blank')
          });

        break;
      case 'app_settings':
        if (!currentUrl.includes('/settings')) {
          this.store.dispatch(SetUserHistorySelection({ value: true }));
          this.router.navigateByUrl('/settings');
        }
        break;
      case 'user_guide':
        if (!currentUrl.includes('/userguide')) {
          this.store.dispatch(SetUserHistorySelection({ value: true }));
          this.router.navigateByUrl('/userguide');
        }
        break;
      case 'approvals':
        this.store.dispatch(SetPreviousUrl({ url: this.router.url }));
        this.store.dispatch(SetUserHistorySelection({ value: true }));
        this.router.navigateByUrl('/approvals');
        break;
      case 'send_invite':
        this.store.dispatch(SetUserHistorySelection({ value: true }));
        this.router.navigateByUrl('/inviteuser/sendinvite');
        break;
      case 'scan_qr':
        this.store.dispatch(SetUserHistorySelection({ value: true }));
        this.router.navigateByUrl('/scanqr');
        break;
      case 'Pre-Trip Request':
        this.store.dispatch(SetPreviousUrl({ url: this.router.url }));
        this.store.dispatch(SetUserHistorySelection({ value: true }));
        this.router.navigateByUrl('/travelrequest');
        break;
      case 'Contact Tracing':
        this.store.dispatch(SetPreviousUrl({ url: this.router.url }));
        this.store.dispatch(SetUserHistorySelection({ value: true }));
        this.router.navigateByUrl('/contacttracing');
        break;
      case 'My PcP':
        this.store.dispatch(SetUserHistorySelection({ value: true }));
        this.router.navigateByUrl('/mycertifications');
        break;
      case 'Country Information':
        this.store.dispatch(SetPreviousUrl({ url: this.router.url }));
        this.store.dispatch(SetUserHistorySelection({ value: true }));
        this.router.navigateByUrl('/countryinformation');
        break;
    }
  }

  // Fuction to open footer image
  onFooter() {
    this.bannerDialog.open(BannerpreviewdialogComponent, {
      maxHeight: '90vh',
      panelClass: 'custom-dialog-container',
      data: 'assets/images/checkout_img.png',
      viewContainerRef: this.viewRef,
      height:'400px',
      width:'650px'
    });
  }

  // Function to listen for route changes;
  routeChanges = () => {
    // Subscribe to router events
    this.router.events.subscribe(response => {
      // Check response to be an instance of NavigationEnd

      if (response instanceof NavigationStart) {
        this.routeLoading = true;
      }

      if (response instanceof NavigationEnd) {
        this.routeLoading = false;

        if (response.url === '/dashboard/self' ||
          response.url === '/dashboard/proxy' ||
          response.url === '/dashboard/proxy?new=%20') {
          this.showInternal = true;
        } else {
          this.showInternal = false;
        }

        if (response.url.includes('dashboard') ||
          response.url.includes('internal') ||
          response.url.includes('external') ||
          response.url.includes('login') ||
          response.url.includes('forgotpassword') ||
          response.url.includes('resetpassword') ||
          response.url.includes('register') ||
          response.url === '/') {
          this.onDashboard = true;
        } else {
          this.onDashboard = false;
        }
      }
    });
  }
}
